import loadable from '@loadable/component';

export const CmsFourArticlesHighlightBlockLoadable = loadable(
  () => import('./CmsFourArticlesHighlightBlock'),
  { resolveComponent: (module) => module.CmsFourArticlesHighlightBlock },
);
